module.exports = __webpack_public_path__ + "static/media/0150_Small.42912faf.jpg";